import React from 'react';
import { makeStyles } from '@material-ui/styles';
// import { Typography } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';

import { useTranslation } from 'react-i18next';
import { Page, PageHeader } from 'components';
import PropertiesTable from './components/PropertiesTable';
import { useOrganizations } from 'hooks';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    width: '100%',
    height: '100%',
    minHeight: '100%',
    flex: 1,
  },
  header: {
    marginBottom: theme.spacing(2),
  },
}));

const PropertiesPage = () => {
  const classes = useStyles();
  const pageProps = {};
  const { t } = useTranslation();
  const { selectedOrganization } = useOrganizations();
  pageProps.actionFab = !!selectedOrganization && !!selectedOrganization?.id ? true : false;
  pageProps.actionHref = '/properties/create';
  pageProps.action = 'property_new';
  pageProps.icon = <AddIcon />;
  return (
    <Page title={t('property_plural')} className={classes.root}>
      <PageHeader
        title={!selectedOrganization || !selectedOrganization?.id ? 'select_organization' : 'property_plural'}
        {...pageProps}
        className={classes.header}
      />
      <div style={{ marginBottom: 16 }} />
      {pageProps.actionFab && <PropertiesTable />}
    </Page>
  );
};

export default PropertiesPage;
